import { render, staticRenderFns } from "./ArrowLeftIcon.vue?vue&type=template&id=3cd20862&scoped=true&"
import script from "./ArrowLeftIcon.vue?vue&type=script&lang=ts&"
export * from "./ArrowLeftIcon.vue?vue&type=script&lang=ts&"
import style0 from "./ArrowLeftIcon.vue?vue&type=style&index=0&id=3cd20862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd20862",
  null
  
)

export default component.exports